import { useEffect, useState } from 'react';

export default function useMobileViewport(enabled) {
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    if (!enabled || !window.visualViewport) return;
    const viewport = window.visualViewport;
    const root = document.documentElement;
    let height = Math.max(window.innerHeight, viewport.height), width = viewport.width, frame;
    const update = () => {
      frame = undefined;
      if (Math.abs(viewport.scale - 1) > .01) return; // Pinch zoom is not a keyboard.
      if (Math.abs(viewport.width - width) > 50) { width = viewport.width; height = window.innerHeight; }
      height = Math.max(height, viewport.height);
      const editable = document.activeElement?.matches('input:not([type=checkbox]):not([type=radio]), textarea, [contenteditable="true"]');
      const open = !!editable && height - viewport.height > Math.max(150, height * .2);
      setKeyboardOpen(open);
      root.classList.toggle('erp-keyboard-open', open);
      root.style.setProperty('--erp-visible-height', `${viewport.height}px`);
      root.style.setProperty('--erp-viewport-top', `${viewport.offsetTop}px`);
    };
    const schedule = () => { if (frame === undefined) frame = requestAnimationFrame(update); };
    viewport.addEventListener('resize', schedule);
    viewport.addEventListener('scroll', schedule);
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    update();
    return () => {
      cancelAnimationFrame(frame);
      viewport.removeEventListener('resize', schedule);
      viewport.removeEventListener('scroll', schedule);
      document.removeEventListener('focusin', schedule);
      document.removeEventListener('focusout', schedule);
      root.classList.remove('erp-keyboard-open');
      root.style.removeProperty('--erp-visible-height');
      root.style.removeProperty('--erp-viewport-top');
    };
  }, [enabled]);
  return keyboardOpen;
}
